// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery';

if($(document).width() >= 768)
{
  $('.menu-item-has-children').on('mouseover',function(){
    $('.sub-menu').stop().slideDown();
  });
  $('.menu-item-has-children').on('mouseleave',function(){
    $('.sub-menu').stop().slideUp();
  });
}
else {
  $('.menu-item-has-children').on('click',function(){
    $('.sub-menu').slideToggle();
  });
}



// WEBPACK FOOTER //
// ./resources/assets/js/app.js